import {
  ErrorContext,
  MessageContext,
  captureError,
  captureMessage,
} from '@leagueplatform/observability';
import { SentryOwnershipTeam } from 'constants/app';
import { AppTenant } from 'types';
import { isValidTenantId } from './is-valid-tenant-id';

export const captureErrorWithTenant = (
  error: Error,
  tenantId: AppTenant | string | undefined,
  context?: ErrorContext,
) => {
  const tags: NonNullable<ErrorContext['tags']> = {
    ...(context?.tags ?? {}),
  };

  // calling this appTenant instead of tenantId, since the observability module will send the tenantId automatically as our appId.
  if (tenantId && isValidTenantId(tenantId)) {
    tags.appTenant = tenantId;
  } else if (tenantId) {
    // If we have some tenantId string but it doesn't match AppTenant, still tag it for debugging.
    tags.selectedTenantId = tenantId;
  }

  const contextWithTenantTag = {
    ...context,
    ownershipTeam: SentryOwnershipTeam,
    tags,
  };
  captureError(error, contextWithTenantTag);
};

export const captureMessageWithOwner = (
  message: string,
  context?: Omit<MessageContext, 'ownershipTeam'>,
) => {
  captureMessage(message, { ...context, ownershipTeam: SentryOwnershipTeam });
};
